import type { ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'

export type ContentProps = {
  children?: ReactNode
  className?: string
  /** Ref to the scrollable content element. */
  ref?: Ref<HTMLDivElement>
}

export const Content = ({ children, className, ref }: ContentProps) => {
  return (
    <div
      ref={ref}
      className={cn('min-h-0 flex-1 overflow-y-auto', className)}
    >
      {children}
    </div>
  )
}
